module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "work-information"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isProductLoading),
      expression: "!isProductLoading"
    }],
    staticClass: "bk-info-box"
  }, [_c('div', {
    staticClass: "video"
  }, [_c('h4', [_vm._v("\n\t  \t  \t作品视频\n\t  \t  \t"), _c('span', {
    staticClass: "bk-word"
  }, [_vm._v("可添加作品的相关视频介绍资料，加深用户对作品的认知")]), _vm._v(" "), _c('span', {
    staticClass: "bk-num"
  }, [_c('span', [_vm._v(_vm._s(_vm.videoList.length))]), _vm._v("/10\n\t  \t  \t")])]), _vm._v(" "), _c('div', {
    staticClass: "bk-add-video"
  }, [_c('ul', {
    staticClass: "bk-video-list"
  }, [_vm._l((_vm.videoList), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "bk-video-img",
      on: {
        "mouseenter": function($event) {
          return _vm.showCurVideo(index)
        },
        "mouseleave": _vm.hideCurVideo
      }
    }, [_c('img', {
      attrs: {
        "src": item.logo
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === _vm.video.avatarIndex),
        expression: "index === video.avatarIndex"
      }],
      staticClass: "bk-shade",
      on: {
        "click": function($event) {
          return _vm.openChangevideo(item, index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../../images/personal_center/video_re.png")
      }
    }), _vm._v(" "), _c('p', [_vm._v("修改视频信息")]), _vm._v(" "), _c('i', {
      staticClass: "bk-icon icon-error",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.deleteTheVideo(item, index)
        }
      }
    })])]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    })])
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.videoList.length >= 10)),
      expression: "!(videoList.length >= 10)"
    }],
    staticClass: "bk-background",
    on: {
      "click": _vm.openAddvideo
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../images/personal_center/video_add.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("添加新视频")])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.videoList.length === 0 || _vm.videoList.length === 3 || _vm.videoList.length === 6 || _vm.videoList.length === 9 || _vm.videoList.length === 10),
      expression: "videoList.length === 0 || videoList.length === 3 || videoList.length === 6 || videoList.length === 9 || videoList.length === 10"
    }],
    staticClass: "show-line"
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "bk-accessory attention"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.workAccessory),
      expression: "workAccessory"
    }]
  }, [_c('div', {
    staticClass: "bk-add-accessory"
  }, [_c('div', {
    staticClass: "bk-add-btn"
  }, [_c('button', {
    staticClass: "bk-button bk-primary",
    attrs: {
      "title": "上传附件"
    },
    on: {
      "click": _vm.changeDoxc
    }
  }, [_c('i', {
    staticClass: "bk-icon icon-upload"
  }), _vm._v(" "), _c('span', [_vm._v("上传附件")])])]), _vm._v(" "), _c('div', {
    staticClass: "bk-table-list"
  }, [_c('table', {
    staticClass: "bk-table has-table-bordered"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.docxList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.type !== 'ZIP'),
        expression: "item.type !== 'ZIP'"
      }],
      attrs: {
        "src": require("../../../images/personal_center/icondocx.png")
      }
    }), _vm._v(" "), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.type === 'ZIP'),
        expression: "item.type === 'ZIP'"
      }],
      attrs: {
        "src": require("../../../images/personal_center/iconzip.png")
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "bk-img-word",
      attrs: {
        "title": item.name
      },
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    })]), _vm._v(" "), _c('td', [_vm._v("上传时间：" + _vm._s(item.create_time))]), _vm._v(" "), _c('td', [_vm._v("文件大小：" + _vm._s(item.size))]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "bk-icon icon-download",
      on: {
        "click": function($event) {
          return _vm.downLoad(item.doc)
        }
      }
    }, [_c('span', {
      staticClass: "tips",
      on: {
        "click": function($event) {
          return _vm.downLoad(item.doc)
        }
      }
    }, [_vm._v("版本下载")])]), _vm._v(" "), _c('i', {
      staticClass: "bk-icon icon-delete",
      on: {
        "click": function($event) {
          return _vm.deleteDocx(item, index)
        }
      }
    }, [_c('span', {
      staticClass: "tips"
    }, [_vm._v("删除该版本")])])])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.workAccessory),
      expression: "!workAccessory"
    }],
    staticClass: "bk-add-docx"
  }, [_c('div', {
    staticClass: "bk-docx-top"
  }, [_vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "mt20"
  }, [_vm._v("\n\t\t  \t\t\t\t最多仅支持上传10个文件\n\t\t  \t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "mt10"
  }, [_vm._v("\n\t\t  \t\t\t\t单文件最大仅可为 100MB\n\t\t  \t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "mb25 mt10"
  }, [_vm._v("\n\t\t  \t\t\t\t单次上传文件总大小不建议太大，以免影响上传效率体验\n\t\t  \t\t\t")]), _vm._v(" "), _c('input', {
    staticClass: "bk-docx-file",
    attrs: {
      "type": "file",
      "name": "uploadFile"
    },
    on: {
      "change": _vm.handleFile
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bk-docx-content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ableToUpload),
      expression: "ableToUpload"
    }],
    staticClass: "bk-form-content"
  }, [(_vm.files.length !== 0 && _vm.files) ? _c('div', {
    staticClass: "bk-upload-ul"
  }, _vm._l((_vm.uploadFiles), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "bk-list-li"
    }, [_c('i', {
      staticClass: "bk-icon icon-file-zip"
    }), _vm._v(" "), _c('div', {
      staticClass: "bk-list-content"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('i', {
      staticClass: "bk-icon icon-check-1"
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.loadingIndex === index && _vm.loadingStatus === 'start'),
        expression: "loadingIndex === index && loadingStatus === 'start'"
      }],
      staticClass: "bk-load"
    }, [_c('span', {
      class: [{
        'loading': _vm.loadingIndex === index && _vm.loadingStatus === 'start'
      }, {
        'totalLoading': _vm.loadingIndex === index && _vm.loadingStatus === 'complete'
      }]
    }), _vm._v(" "), _c('span')])])])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "bk-docx-bottom"
  }, [_c('button', {
    class: ['bk-button', 'bk-primary', {
      'is-loading': _vm.saveFlag === false
    }],
    attrs: {
      "disabled": _vm.addDisabled
    },
    on: {
      "click": _vm.changeDocxList
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('button', {
    staticClass: "bk-button bk-default",
    on: {
      "click": _vm.changeDoxc
    }
  }, [_vm._v("取消")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shade),
      expression: "shade"
    }],
    staticClass: "bk-open-shade"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addVideo),
      expression: "addVideo"
    }],
    staticClass: "bk-open-addvideo"
  }, [_c('div', {
    staticClass: "bk-open-top"
  }, [_c('div', {
    staticClass: "bk-open-img"
  }, [_c('div', [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.images.coverUploaded),
      expression: "!images.coverUploaded"
    }]
  }, [_vm._v("250x141")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.images.coverUploaded),
      expression: "images.coverUploaded"
    }],
    staticClass: "bk-img",
    attrs: {
      "src": _vm.images.coverImg.indexOf('?') == 0 ? '' : _vm.images.coverImg,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.images.coverUploading),
      expression: "images.coverUploading"
    }],
    staticClass: "mask-loading"
  }, [_vm._m(3)]), _vm._v(" "), _c('input', {
    staticClass: "bk-change-img",
    attrs: {
      "type": "file",
      "name": "avatar",
      "accept": "image/*",
      "title": "更换图片"
    },
    on: {
      "change": function($event) {
        return _vm.imgOnChange($event, 'cover')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bk-open-form"
  }, [_c('form', {
    staticClass: "bk-form"
  }, [_c('div', {
    staticClass: "bk-form-item"
  }, [_c('label', {
    staticClass: "bk-label"
  }, [_vm._v("选择封面：")]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('div', {
    staticClass: "bk-open-file"
  }, [_vm._v("\n\t              \t选择文件\n\t              \t"), _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.imgOnChange($event, 'cover')
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bk-open-span"
  }, [_vm._v("图片类型仅支持jpg/jpeg/png")])])]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item bk-form-mt"
  }, [_c('label', {
    staticClass: "bk-label"
  }, [_vm._v("视频名称：")]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.videoInfo.title),
      expression: "videoInfo.title"
    }],
    staticClass: "bk-form-input",
    class: {
      'bk-input-checked': _vm.classStats.titleShow
    },
    attrs: {
      "type": "text",
      "name": "validation_name",
      "placeholder": "填写该视频内容的主要标题，最多10个字"
    },
    domProps: {
      "value": (_vm.videoInfo.title)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.videoInfo, "title", $event.target.value)
      }, _vm.checkAddTitle]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_c('label', {
    staticClass: "bk-label"
  }, [_vm._v("视频链接：")]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.videoInfo.link),
      expression: "videoInfo.link"
    }],
    staticClass: "bk-form-input",
    class: {
      'bk-input-checked': _vm.classStats.linkShow
    },
    attrs: {
      "type": "text",
      "name": "validation_name",
      "placeholder": "填写该视频的来源URL地址，目前只支持腾讯视频..."
    },
    domProps: {
      "value": (_vm.videoInfo.link)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.videoInfo, "link", $event.target.value)
      }, _vm.checkAddLink]
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "bk-open-bottom"
  }, [_c('button', {
    staticClass: "bk-button bk-primary bk-width ml10",
    on: {
      "click": _vm.changeVideoList
    }
  }, [_vm._v("立即添加")]), _vm._v(" "), _c('button', {
    staticClass: "bk-button bk-default bk-width",
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("取消")])]), _vm._v(" "), _c('div', {
    staticClass: "icon-cell bk-icon-close",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('i', {
    staticClass: "bk-icon icon-close"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeVideo),
      expression: "changeVideo"
    }],
    staticClass: "bk-open-addvideo"
  }, [_c('div', {
    staticClass: "bk-open-top"
  }, [_c('div', {
    staticClass: "bk-open-img"
  }, [_c('div', [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.images.coverUploaded),
      expression: "!images.coverUploaded"
    }],
    staticClass: "bk-img",
    attrs: {
      "src": _vm.changeInfo.logo
    }
  }), _c('p'), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.images.coverUploaded),
      expression: "images.coverUploaded"
    }],
    staticClass: "bk-img",
    attrs: {
      "src": _vm.images.coverImg.indexOf('?') == 0 ? '' : _vm.images.coverImg,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.images.coverUploading),
      expression: "images.coverUploading"
    }],
    staticClass: "mask-loading"
  }, [_vm._m(4)]), _vm._v(" "), _c('input', {
    staticClass: "bk-change-img",
    attrs: {
      "type": "file",
      "name": "avatar",
      "accept": "image/*",
      "title": "更换图片"
    },
    on: {
      "change": function($event) {
        return _vm.imgOnChange($event, 'cover')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bk-open-form"
  }, [_c('form', {
    staticClass: "bk-form"
  }, [_c('div', {
    staticClass: "bk-form-item"
  }, [_c('label', {
    staticClass: "bk-label"
  }, [_vm._v("选择封面：")]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('div', {
    staticClass: "bk-open-file"
  }, [_vm._v("\n\t              \t选择文件\n\t              \t"), _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.imgOnChange($event, 'cover')
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bk-open-span"
  }, [_vm._v("图片类型仅支持jpg/jpeg/png")])])]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item bk-form-mt"
  }, [_c('label', {
    staticClass: "bk-label"
  }, [_vm._v("视频名称：")]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.changeInfo.title),
      expression: "changeInfo.title"
    }],
    staticClass: "bk-form-input",
    class: {
      'bk-input-checked': _vm.changeStats.titleShow
    },
    attrs: {
      "type": "text",
      "name": "validation_name",
      "placeholder": "填写该视频内容的主要标题，最多10个字"
    },
    domProps: {
      "value": (_vm.changeInfo.title)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.changeInfo, "title", $event.target.value)
      }, _vm.checkChangeTitle]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_c('label', {
    staticClass: "bk-label"
  }, [_vm._v("视频链接：")]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.changeInfo.url),
      expression: "changeInfo.url"
    }],
    staticClass: "bk-form-input",
    class: {
      'bk-input-checked': _vm.changeStats.linkShow
    },
    attrs: {
      "type": "text",
      "name": "validation_name",
      "placeholder": "填写该视频的来源URL地址，目前只支持腾讯视频..."
    },
    domProps: {
      "value": (_vm.changeInfo.url)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.changeInfo, "url", $event.target.value)
      }, _vm.checkChangeUrl]
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "bk-open-bottom"
  }, [_c('button', {
    staticClass: "bk-button bk-primary bk-width ml10",
    on: {
      "click": function($event) {
        return _vm.changeVideoInfo()
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('button', {
    staticClass: "bk-button bk-default bk-width",
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("取消")])]), _vm._v(" "), _c('div', {
    staticClass: "icon-cell bk-icon-close",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('i', {
    staticClass: "bk-icon icon-close"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deleteDoc),
      expression: "deleteDoc"
    }],
    staticClass: "bk-open-deletedoc"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "bk-doc-content"
  }, [_c('p', [_vm._v("你正在删除产品"), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.docsInfo)
    }
  }), _vm._v("，删除后数据将无法恢复，请谨慎操作")])]), _vm._v(" "), _c('div', {
    staticClass: "bk-doc-btn"
  }, [_c('button', {
    staticClass: "bk-button bk-danger bk-width",
    on: {
      "click": _vm.deleteIndexDoc
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('button', {
    staticClass: "bk-button bk-default bk-width ml10",
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("取消")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deleteOpenVideo),
      expression: "deleteOpenVideo"
    }],
    staticClass: "bk-open-deletedoc"
  }, [_vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "bk-doc-btn"
  }, [_c('button', {
    staticClass: "bk-button bk-danger bk-width",
    on: {
      "click": _vm.deleteVideo
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('button', {
    staticClass: "bk-button bk-default bk-width ml10",
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("取消")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.images.isShowImageEditor),
      expression: "images.isShowImageEditor"
    }],
    staticClass: "personal-pops"
  }, [_c('div', {
    staticClass: "pops-content"
  }, [_c('h4', [_vm._v("\n\t        " + _vm._s(_vm.images.editImageTitle) + "剪裁\n\t        "), _c('a', {
    staticClass: "fr pops-close",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.closeImageEditor
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../images/personal_center/pops-close.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "editor"
  }, [_c('img', {
    attrs: {
      "src": _vm.images.imageWaitingForCrop,
      "alt": "",
      "id": "editor"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn-row"
  }, [_vm._m(8), _vm._v(" "), _c('button', {
    staticClass: "confirm-image-editor",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.confirmCrop
    }
  }, [_vm._v("确定")])])])]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "options": _vm.options
    }
  }), _vm._v(" "), _c('v-loading', {
    staticClass: "loadingStyle",
    attrs: {
      "ifLoadingStart": _vm.isProductLoading
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_vm._v("\n\t  \t  \t作品附件\n\t  \t  \t"), _c('span', [_vm._v("可上传作品相关的依赖包或产品说明相关的文档等文件")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    staticStyle: {
      "width": "282px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "260px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "170px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "122px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mt20"
  }, [_c('i', {
    staticClass: "bk-icon icon-upload"
  }), _vm._v(" "), _c('span', [_vm._v("将文件拖到此处或")]), _vm._v(" "), _c('span', {
    staticClass: "bk-add"
  }, [_vm._v("点击上传")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-box"
  }, [_c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "strip1 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip2 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip3 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip4 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip5 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip6 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip7 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip8 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip9 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip10 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip11 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip12 strip"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n\t                正在上传图片...\n\t            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-box"
  }, [_c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "strip1 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip2 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip3 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip4 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip5 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip6 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip7 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip8 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip9 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip10 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip11 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip12 strip"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n\t                正在上传图片...\n\t            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bk-doc-top"
  }, [_c('p', [_vm._v("请确认是否删除")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bk-doc-top"
  }, [_c('p', [_vm._v("请确认是否删除")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bk-doc-content"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("你是否确定要删除该作品视频？")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fl"
  }, [_c('a', {
    staticClass: "btn",
    attrs: {
      "type": "button",
      "data-type": "controller",
      "data-method": "zoom",
      "data-options": "0.1",
      "title": "放大"
    }
  }, [_c('span', {
    staticClass: "docs-tooltip"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-zoom-in",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "type": "button",
      "data-type": "controller",
      "data-method": "zoom",
      "data-options": "-0.1",
      "title": "缩小"
    }
  }, [_c('span', {
    staticClass: "docs-tooltip"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-zoom-out",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "type": "button",
      "data-type": "controller",
      "data-method": "move",
      "data-options": "-10",
      "data-second-options": "0",
      "title": "左移"
    }
  }, [_c('span', {
    staticClass: "docs-tooltip"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "type": "button",
      "data-type": "controller",
      "data-method": "move",
      "data-options": "10",
      "data-second-options": "0",
      "title": "右移"
    }
  }, [_c('span', {
    staticClass: "docs-tooltip"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-arrow-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "type": "button",
      "data-type": "controller",
      "data-method": "move",
      "data-options": "0",
      "data-second-options": "-10",
      "title": "上移"
    }
  }, [_c('span', {
    staticClass: "docs-tooltip"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-arrow-up",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "type": "button",
      "data-type": "controller",
      "data-method": "move",
      "data-options": "0",
      "data-second-options": "10",
      "title": "下移"
    }
  }, [_c('span', {
    staticClass: "docs-tooltip"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-arrow-down",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-e41d37bc!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal_center/works/work_information.vue
// module id = 7OkT
// module chunks = 16